module.exports = __webpack_public_path__ + "img/acc.bf203c1f.webp";